const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the Polls results Directive to display poll results
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Events the resource defined to get and set Events data
 */
app.directive('pollsResults', ['Application', 'Authorization', 'Polls', '$translate', function (Application, Authorization, Polls, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
    },
    template: require('../../templates/directives/polls-results.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.translations = {};
      Application.scrollTop();

      self.info = {
        poll: null,
        pollId: Application.navigation.getRouteParameters().id,
        user: Authorization.getAuthToken().user,
        resultOptions: {
          a: 'results_a',
          b: 'results_b',
          c: 'results_c',
          d: 'results_d',
          e: 'results_e'
        },
        usersDirectory: {},
        emojiNames: {
          '&#x1F44D;': self.translations['pollsResults.thumbs_up'],
          '&#x1F44E;': self.translations['pollsResults.thumbs_down'],
          '&#x1F642;': self.translations['pollsResults.smile_face'],
          '&#x1F610;': self.translations['pollsResults.meh_face'],
          '&#x1F641;': self.translations['pollsResults.frown_face']
        }
      };

      self.results = {
        type: 'bar',
        categories: {},
        chartData: {},
        barResults: {},
        originalUserData: {},
        originalData: null,
        answerLabels: [],
        totalVotes: 0,
        parse: function() {
          this.data = [[]];
          this.labels = [];
          this.chartData = {};
          this.barResults = {};
          for (var i = 0; i < self.info.poll.answers.length; i++) {
            var resultName = self.info.resultOptions[self.info.poll.answers[i].value];
            if (!resultName || !self.info.poll[resultName]) {
              continue;
            }
            this.answerLabels.push(resultName);
            this.data[0].push(self.info.poll[resultName].length);
            this.chartData[self.info.poll.answers[i].label] = self.info.poll[resultName].length;
            this.labels.push(self.info.poll.answers[i].label);

            this.barResults[i] = {
              "label": self.info.poll.answers[i].label,
              "value": self.info.poll[resultName].length,
              "percent": 0
            };
          }

          var totalResponds = self.info.poll.users_responded.length;
          for (var key in this.barResults) {
            var valueAsNumber = parseInt(this.barResults[key].value);
            if (valueAsNumber) {
              this.barResults[key].percent = Math.round(valueAsNumber / totalResponds * 100);
            }
          }
        },
        data: [[]],
        labels: [],
        options: {
          title: {
            display: true,
            text: 'Custom Chart Title'
          },
          legend: {
            display: true,
            position: 'left'
          }
        },
        showCsvMessage: false,
        promptSubset: function() {
          if (self.searchItems.active) {
            this.showCsvMessage = true;
            return;
          }
          this.showCsvMessage = false;
          this.downloadCsv();
        },
        downloadCsv: function() {
          var userHeadings = ['Name', 'Email', 'Department', 'Location', 'Answer'];
          var totalsHeadings = this.labels;

          var data = [];
          if (!self.info.poll.anonymous_results) {
            data.push(userHeadings);
            var userData = self.searchItems.active ? self.searchItems.userData : self.results.originalUserData;

            for (var key in userData) {
              userData[key].forEach(function(user) {
                var dep = self.results.categories.departments[user.linked_departments[0]] ? self.results.categories.departments[user.linked_departments[0]].name : '';
                var loc = self.results.categories.locations[user.linked_locations[0]] ? self.results.categories.locations[user.linked_locations[0]].name : '';
                var label = self.info.emojiNames[key] || key;
                data.push([
                  user.full_name,
                  user.email,
                  dep,
                  loc,
                  label
                ]);
              });
            }

            data.push(['Totals']);
          }

          data.push(totalsHeadings.map(function(item) {
            return self.info.emojiNames[item] || item;
          }));

          data.push(this.data[0]);


          var csvContent = "data:text/csv;charset=utf-8,";
          data.forEach(function(line, index){
           var csvLine = line.join(',');
           csvContent += index < data.length ? csvLine + "\n" : csvLine;
          }); 
          var encodedUri = encodeURI(csvContent);
          var linkedAnchor = document.createElement("a");
          linkedAnchor.setAttribute('href', encodedUri);
          linkedAnchor.setAttribute('download', 'poll-' + self.info.poll._id + '.csv');
          document.body.appendChild(linkedAnchor);

          linkedAnchor.click();
          linkedAnchor.parentNode.removeChild(linkedAnchor);
          this.showCsvMessage = false;
        }
      };

      self.users = {
        fullList: [],
        activeList: [],
        page: 1,
        perPage: 15,
        init: function(users) {
          if (self.info.poll.anonymous_results) {
            return;
          }
          this.fullList = [];
          this.actvieList = [];
          this.page = 1;
          this.fullList = users;
          this.activeList = this.fullList.slice(0, this.perPage);
        },
        next: function() {
          if (this.activeList.length < this.perPage) {
            return;
          }
          this.page++;
          this.activeList = this.fullList.slice((this.page - 1) * this.perPage, this.perPage * this.page);
        },
        previous: function() {
          if (this.page <= 1) {
            return;
          }
          this.page--;
          this.activeList = this.fullList.slice((this.page - 1) * this.perPage, this.perPage * this.page);
        },
        getLocation: function(location) {
          if (!location || !self.results.categories || !self.results.categories.locations) {
            return '----';
          }
          return self.results.categories.locations[location] ? self.results.categories.locations[location].name : '----';
        },
        getDepartment: function(department) {
          if (!department || !self.results.categories || !self.results.categories.departments) {
            return '----';
          }
          return self.results.categories.departments[department] ? self.results.categories.departments[department].name : '----';
        },
        getSelection: function(user) {
          if (!user) {
            return '----';
          }
          for (var i = 0; i < self.info.poll.answers.length; i++) {
            if (self.info.poll['results_' + [self.info.poll.answers[i].value]] && self.info.poll['results_' + [self.info.poll.answers[i].value]].indexOf(user) !== -1) {
              return self.info.poll.answers[i].label;
            }
          }
          return '----';
        },
        goTo: function(user) {
          if (!user) {
            return;
          }
          Application.navigation.goTo('/edit/users/' + user);
        }
      };

      self.searchItems = {
        active: false,
        placeholder: self.translations['pollsResults.filter_results_by'],
        userData: {},
        onQuery: function(opts) {
          function setCharts() {
            var totalResponds = 0;
            for (var i = 0; i < self.info.poll.answers.length; i++) {
              self.results.chartData[self.info.poll.answers[i].label] = self.results.data[0][i];
              self.results.barResults[i] = {
                "label": self.info.poll.answers[i].label,
                "value": self.results.data[0][i],
                "percent": 0
              };
              totalResponds += parseInt(self.results.data[0][i]);
            }

            for (var key in self.results.barResults) {
              var valueAsNumber = parseInt(self.results.barResults[key].value);
              if (valueAsNumber) {
                self.results.barResults[key].percent = Math.round(valueAsNumber / totalResponds * 100);
              }
            }
          };

          var checkLocations = !!opts.privacy_locations;
          var checkDepartments = !!opts.privacy_departments;

          var locations = checkLocations ? opts.privacy_locations.split(',').slice(2) : [];
          var departments = checkDepartments ? opts.privacy_departments.split(',').slice(2) : [];

          if (!checkLocations && !checkDepartments) {
            self.results.data = self.results.originalData;
            setCharts();
            this.active = false;
            self.users.init(self.info.poll.users_responded);
            return;
          }

          this.active = true;

          var filteredData = [[]];
          var allUsers = [];
          this.userData = {};
          self.results.chartData = {};
          self.results.barResults = {};

          self.results.labels.forEach(function(label, index) {
            filteredData[0][index] = 0;
            self.searchItems.userData[label] = [];

            self.info.poll[self.results.answerLabels[index]].forEach(function(userId) {
              var userLocations = self.info.usersDirectory[userId].linked_locations;
              var userDepartments = self.info.usersDirectory[userId].linked_departments;
              if (checkLocations) {
                if (!userLocations || !userLocations[0] || locations.indexOf(userLocations[0]) === -1) {
                  return;
                }
              }
              if (checkDepartments) {
                if (!userDepartments || !userDepartments[0] || departments.indexOf(userDepartments[0]) === -1) {
                  return;
                }
              }

              self.searchItems.userData[label].push(self.info.usersDirectory[userId]);
              allUsers.push(self.info.usersDirectory[userId]);
              filteredData[0][index]++;

            });
          });

          self.results.data = filteredData;
          self.users.init(allUsers);
          setCharts();

        }
      };

      self.initialize = function() {
        if (!self.info.user || !self.info.user.role || (self.info.user.role !== 'admin' && self.info.user.role !== 'creator')) {
          Application.navigation.goHome();
          return;
        }

        Polls.get({subresource: self.info.pollId, 'users_responded-populate': 'first_name,last_name,full_name,email,linked_departments,linked_locations', fields: 'title,question,answers,anonymous_results,users_responded,users_responded-populate,results_a,results_b,results_c,results_d,results_e'}).$promise
        .then(function(poll) {
          self.info.poll = poll;
          self.users.init(poll.users_responded);
          self.results.parse();
          self.results.originalData = JSON.parse(JSON.stringify(self.results.data));
          if (!poll.anonymous_results) {
            poll.users_responded.forEach(function(user) {
              self.info.usersDirectory[user._id] = user;
            });
            self.results.answerLabels.forEach(function(answerLabel, index) {
              self.results.originalUserData[self.results.labels[index]] = [];
              self.info.poll[answerLabel].forEach(function(item) {
                self.results.originalUserData[self.results.labels[index]].push(self.info.usersDirectory[item]);
              });
            });
          }
        });

      };

      $translate([
        'pollsResults.thumbs_up',
        'pollsResults.thumbs_down',
        'pollsResults.smile_face',
        'pollsResults.meh_face',
        'pollsResults.frown_face',
        'pollsResults.filter_results_by',
      ]).then(function (translations) {
        self.translations = translations;
        self.initialize();
      });

    }],
    controllerAs: 'poll'
  };
}]);